import React, { useEffect, useState } from "react"
import Modal from "react-bootstrap/lib/Modal"

const MIN_HOLDER_NAME_LENGTH = 5

function isAmex(card) {
  return card && card.brand === "American Express"
}

export default function AddStripeCreditCardModal(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { show, onHide, stripe_key, onNewCreditCardError, onNewCreditCard } =
    props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [state, setState] = useState({
    loading: false,
    inputDisabled: true,
    holderName: "",
  })

  const [stripeState, setStripeState] = useState({
    stripe: null,
    cardNumberElement: null,
  })

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    if (show === true) {
      // wait modal animation
      setTimeout(() => {
        setupStripeElements()
      }, 500)
    }
  }, [show])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function setupStripeElements() {
    let stripe = Stripe(stripe_key)
    let elements = stripe.elements()

    const style = {
      style: {
        base: {
          fontSize: "16px",
        },
        empty: {
          "::placeholder": {
            color: "#ccc",
          },
        },
      },
    }
    let cardNumberElement = elements.create("cardNumber", style)
    cardNumberElement.mount("#cardNumber")
    elements.create("cardExpiry", style).mount("#cardExpiry")
    elements.create("cardCvc", style).mount("#cardCvc")

    setStripeState({
      ...state,
      stripe: stripe,
      cardNumberElement: cardNumberElement,
    })
  }

  function handleSubmit(event) {
    // Prevent the form from being submitted:
    event.preventDefault()

    if (state.inputDisabled === true) {
      return
    }

    setState({ ...state, loading: true })

    stripeState.stripe
      .createPaymentMethod({
        type: "card",
        card: stripeState.cardNumberElement,
        billing_details: { name: state.holderName },
      })
      .then((result) => {
        setState({ ...state, loading: false })

        if (result.error) {
          onNewCreditCardError(
            I18n.t("cart_summary.credit_cards.cannot_use_this_card")
          )
        } else {
          const { paymentMethod } = result

          const { card } = paymentMethod

          if (isAmex(card) === true) {
            onNewCreditCardError(
              I18n.t("cart_summary.credit_cards.cannot_use_amex_card")
            )
            return
          }

          onNewCreditCard(paymentMethod)
        }
      })
      .catch((error) => {
        setState({ ...state, loading: false })
        onNewCreditCardError(
          I18n.t("cart_summary.credit_cards.cannot_use_this_card")
        )
      })
  }

  function handleHolderNameChange(event) {
    const name = event.target.value || ""

    setState({
      ...state,
      holderName: event.target.value,
      inputDisabled: name.length < MIN_HOLDER_NAME_LENGTH,
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="modal modal--full-height cart-summary-modal"
      animation={true}
    >
      <Modal.Header>
        <Modal.Title>
          {I18n.t("cart_summary.credit_cards.add_new_credit_card_title")}
        </Modal.Title>
        <button
          className="close"
          aria-label="Close"
          data-dismiss="modal"
          type="button"
          onClick={onHide}
        >
          <i className="fal fa-times" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form id="payment-form">
          <span className="payment-errors" />

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group has-feedback">
                <label htmlFor="holder_name">
                  {I18n.t("cart_summary.credit_cards.form.holder_name")}
                </label>
                <input
                  className="stripe-input"
                  name="holder_name"
                  type="text"
                  value={state.holderName}
                  onChange={handleHolderNameChange}
                />
              </div>
            </div>
            <div className="col-sm-12">
              <div className="form-group has-feedback">
                <label htmlFor="cardnumber">
                  {I18n.t("cart_summary.credit_cards.form.number")}
                </label>
                <div className="stripe-input" id="cardNumber" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <div className="form-group has-feedback">
                <label htmlFor="exp-date">
                  {I18n.t("cart_summary.credit_cards.form.expiration")}
                </label>
                <div className="stripe-input" id="cardExpiry" />
              </div>
            </div>
            <div className="col-xs-12 col-sm-6">
              <div className="form-group has-feedback">
                <label htmlFor="cvc">
                  {I18n.t("cart_summary.credit_cards.form.cvc")}
                </label>
                <div className="stripe-input" id="cardCvc" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <p className="small-text">
                {I18n.t("cart_summary.credit_cards.supported_card_types")}
              </p>
              <p className="small-text">
                {I18n.t("cart_summary.credit_cards.secure_payment_notice")}
              </p>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="row">
          <div className="col-sm-12 col-md-8 col-md-push-2">
            <p>
              <a
                className="cc-submit btn btn-primary btn-block"
                onClick={handleSubmit}
                disabled={state.loading || state.inputDisabled}
                href=""
              >
                {I18n.t("cart_summary.credit_cards.add_new_credit_card_button")}
              </a>
            </p>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
